module.exports = __webpack_public_path__ + "static/media/placeholder_600.bdbbb4ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder_600.jpg
// module id = 154
// module chunks = 0